import { memo } from "react";

import { buildBuilderUserAttributesInlineJs } from "./builder-user-attributes";

/**
 * COM-101: write `builder.userAttributes` at HTML parse time, before the
 * Builder SDK's inlined personalization scripts run (those live inside
 * `<Content>` later in the tree). The root `useEffect` setter is too late —
 * it runs after hydration, and an empty cookie at parse time is why
 * data-bound Symbols reverted to defaults on Safari.
 *
 * Merges into the existing cookie exactly like that effect does (dead
 * `removals` deleted, fresh keys win, everything else kept) — see
 * `buildBuilderUserAttributesInlineJs`.
 *
 * Rendered as the first of the contiguous body-top inline-script run in
 * `root.tsx`. Hydration-safe (loader data is identical on server and client);
 * browsers do not re-execute the tag on hydrate. CSP-nonce'd.
 */
export const BuilderUserAttributesInlineScript = memo(
  function BuilderUserAttributesInlineScript({
    attributes,
    removals,
    nonce,
  }: {
    attributes: Record<string, string | boolean>;
    /** Dead cookie keys from the server-side reconcile (`attrRemovals`). */
    removals?: readonly string[];
    nonce?: string;
  }) {
    return (
      <script
        suppressHydrationWarning
        nonce={nonce}
        dangerouslySetInnerHTML={{
          __html: buildBuilderUserAttributesInlineJs(attributes, removals),
        }}
      />
    );
  },
);
